/**
 * 074 (2026-10-21, właściciel): protokół usunięty w CEEB — jeden tekst dla wiersza listy budynków, widoku budynku
 * i okna odpięcia numeru sprawy. Nocny pełny skan nie znalazł protokołu na liście CEEB (wersja robocza usunięta,
 * Bolesława Prusa 7/10). Usuniętego protokołu NIE da się przywrócić — jedyna droga to nowa wersja robocza, którą
 * zakłada następne „Wyślij do CEEB” (Faza A, create-first, na istniejącej nieruchomości). Żadnej akcji „przywróć”.
 */

/** Data wykrycia jako „21.10” (czas polski); brak/śmieć → null. */
export function deletedDetectedLabel(detectedAt?: string | null): string | null {
  if (!detectedAt) return null;
  const d = new Date(detectedAt);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', day: '2-digit', month: '2-digit' }).format(d);
}

/** Krótko (wiersz listy): „Protokół 187138/2026 usunięty w CEEB (wykryto 21.10)”. */
export function ceebDeletedShort(caseNumber: string, detectedAt?: string | null): string {
  const kiedy = deletedDetectedLabel(detectedAt);
  return `Protokół ${caseNumber} usunięty w CEEB${kiedy ? ` (wykryto ${kiedy})` : ''}`;
}

/** Pełny tekst (widok budynku, podpowiedź): krótka wersja + jedyna droga dalej. */
export function ceebDeletedFull(caseNumber: string, detectedAt?: string | null): string {
  return `${ceebDeletedShort(caseNumber, detectedAt)}. Nie da się go przywrócić — „Wyślij do CEEB” założy nową wersję roboczą.`;
}
